"use client";

import { Component, type ErrorInfo, type ReactNode } from "react";

import { SectionErrorFallback } from "@/shared/ui/error-fallback";

type SectionErrorBoundaryProps = {
  children: ReactNode;
  sectionTitle?: string;
};

type SectionErrorBoundaryState = {
  hasError: boolean;
};

export class SectionErrorBoundary extends Component<
  SectionErrorBoundaryProps,
  SectionErrorBoundaryState
> {
  state: SectionErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): SectionErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(
      `[SectionErrorBoundary${this.props.sectionTitle ? `: ${this.props.sectionTitle}` : ""}]`,
      error,
      info.componentStack,
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <SectionErrorFallback sectionTitle={this.props.sectionTitle} />
      );
    }

    return this.props.children;
  }
}
